import dayjs from "dayjs";

export const formattedDate = (dayConvert: string): string => {
  const formatted = dayjs(dayConvert).format("DD.MM.YYYY");
  return formatted !== "Invalid Date" ? formatted : "-";
};

export const formatDateNumber = (number: number) => {
  return number?.toString().padStart(2, "0");
};

export const formatMilliSecondsToMMSS = (milliseconds: number) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};
